import React from "react";
import { WithStyles } from "@material-ui/core";
import { FormRenderProps } from "react-final-form";

type Icon = React.FC<React.HTMLAttributes<any>>;

export interface IInstance {
  id: number;
  submitButtonText?: string | null;
  cancelButtonText?: string | null;
  saveCallback: TWizardSaveCallback | null;
  getButtonConfigs: TWizardButtonConfigsCallback | null;
  resolveCallback: ((data: any) => void) | null;
  submitButtonColor?: SubmitButtonColor | null;
  steps: IWizardStep[];
  mode?: WizardMode | null;
  initialData: any;
  showSuccessNotification?: boolean;
}

export enum WizardMode {
  Create = "Create",
  Edit = "Edit",
  View = "View",
  Delete = "Delete",
}

export enum SubmitButtonColor {
  Default = "Default",
  Success = "Success",
  Info = "Info",
  Danger = "Danger",
}

export interface IWizardProviderContext {
  openWizard: (options: IWizardConfig) => Promise<any>;
  closeWizard: (id: number) => void;
}

export interface IWizardStepContent extends FormRenderProps {
  stepName: string;
  formData: any;
}

export type TWizardSaveCallback = (data: any) => Promise<IWizardResponse>;
export type TWizardButtonConfigsCallback = (values: any) => IButtonConfigs;

export interface IWizardConfig {
  submitButtonText?: string | null;
  submitButtonColor?: SubmitButtonColor | null;
  cancelButtonText?: string | null;
  steps: IWizardStep[];
  saveCallback?: TWizardSaveCallback;
  getButtonConfigs?: TWizardButtonConfigsCallback;
  getData?: (data?: any) => Promise<any>;
  getInitialData?: () => Promise<any>;
  mode?: WizardMode;
  showSuccessNotification?: boolean;
}

export interface IProgramWizardConfigs {
  getCreateConfig: (id?: string) => IWizardConfig;
  getCloneConfig?: (id?: string) => IWizardConfig;
  getViewConfig: (id: string) => IWizardConfig;
  getEditConfig: (id: string) => IWizardConfig;
  getDeleteConfig: (id: string) => IWizardConfig;
  getActivateConfig: (id: string) => IWizardConfig;
  getDeactivateConfig: (id: string) => IWizardConfig;
}

export interface IAcademicWizardConfigs {
  getCreateConfig: (id?: string) => IWizardConfig;
  getViewConfig: (id: string) => IWizardConfig;
  getEditConfig: (id: string) => IWizardConfig;
  getDeleteConfig: (id: string) => IWizardConfig;
  getActivateConfig: (id: string) => IWizardConfig;
  getDeactivateConfig: (id: string) => IWizardConfig;
}

export interface ILanguageCourseWizardConfigs {
  getCreateConfig: () => IWizardConfig;
  getEditConfig: (id: string) => IWizardConfig;
  getViewConfig: (id: string) => IWizardConfig;
  getDeactivateConfig: (id: string) => IWizardConfig;
  getActivateConfig: (id: string) => IWizardConfig;
  getDeleteConfig: (id: string) => IWizardConfig;
}

export interface IServicesWizardConfigs {
  getCreateConfig: () => IWizardConfig;
  getEditConfig: (id: string) => IWizardConfig;
  getViewConfig: (id: string) => IWizardConfig;
  getDeleteConfig: (id: string) => IWizardConfig;
}

export interface IIntakeWizardConfigs {
  getActivateConfig: (id: string) => IWizardConfig;
  getDeactivateConfig: (id: string) => IWizardConfig;
  getDeleteIntakeConfig: (id: string) => IWizardConfig;
}

export interface IEditIntakeWizardConfigs {
  getDeactivateConfig: ({
    approved,
    pending,
  }: {
    approved: string;
    pending: string;
  }) => IWizardConfig;
  getDeleteIntakeConfig: ({
    approved,
    pending,
  }: {
    approved: string;
    pending: string;
  }) => IWizardConfig;
}

export interface IWizardProps {
  submitButtonText?: string | null;
  cancelButtonText?: string | null;
  submitButtonColor?: SubmitButtonColor | null;
  steps: IWizardStep[];
  saveCallback?: TWizardSaveCallback | null;
  getButtonConfigs?: TWizardButtonConfigsCallback | null;
  getData?: (data?: any) => Promise<any>;
  resolveCallback: ((data?: any) => void) | null;
  mode?: WizardMode | null;
  initialData?: any;
  showSuccessNotification?: boolean;
}

export interface IWizard extends IWizardProps {
  id: number;
  setStepValidity: (
    instanceId: number,
    stepIndex: number,
    isValid: boolean,
  ) => void;
  deleteInstance: (id: number) => void;
}

export interface IWizardResponse {
  data?: any;
}

interface IButtonConfig {
  text?: string;
  color?: SubmitButtonColor;
}

interface IButtonConfigs {
  submitButton: IButtonConfig | null;
  cancelButton?: IButtonConfig | null;
}

interface IValidatorParams {
  values: any;
  activeStepName: string;
  // activeTabId: string;
  backendValidator?: (data?: any) => Promise<any>;
}

export type TValidator = (params: IValidatorParams) => Promise<void | Object>;

export interface IWizardStep {
  width?: string;
  isInvalid?: boolean;
  titleConfig?: IWizardTitleConfig;
  content: React.FC<IWizardStepContent> | string;
  validator?: TValidator;
  // innerValidator?: TValidator;
  stepName?: string;
  errorParser?: (errors: any, data: any) => any;
  backendValidator?: (data?: any) => Promise<any>;
  programType?: string;
}

export interface IWizardTitleConfig {
  Icon?: Icon;
  ErrorIcon?: Icon;
  titleText: string;
  info?: string;
}

export interface IWizardStepBar {
  steps: IWizardStep[];
  activeStepIndex: number;
}

export interface IWizardDialogTitleProps extends WithStyles {
  id: string;
  onClose: () => void;
  activeStepIndex: number;
  steps: IWizardStep[];
}
